import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'
import MenuItem from '../Item'

@inject('menuStore')
@observer
export default class Item extends Component {
  constructor(props) {
    super(props)
    // 用于延时处理鼠标移入移出切换菜单
    this.isIn = false

    this.state = {
      isActive: false
    }
  }

  render() {
    const {
      item: { id, path, absolutePath },
      menuStore: { menuData, onMenuClick, isFirstLevelId, onMenuOpenChange }
    } = this.props
    const isMenuSelected = menuData.selectedKey === id

    return (
      <MenuItem
        item={this.props.item}
        isActive={this.state.isActive}
        isMenuSelected={isMenuSelected}
        onMouseEnter={() => {
          this.isIn = true

          setTimeout(() => {
            if (this.isIn) {
              if (isFirstLevelId(id)) {
                onMenuOpenChange(menuData.selectedKeyPath[0])
              }
              this.setState({ isActive: true })
            }
          }, 100)
        }}
        onMouseLeave={() => {
          this.isIn = false
          this.setState({ isActive: false })
        }}
        href={`#${path}`}
        onClick={e => {
          e.preventDefault()
          if (absolutePath) {
            window.location.href = absolutePath
          } else {
            hashHistory.push(path)
            if (!isMenuSelected) {
              onMenuClick(id, '', path)
            }
          }
        }}
      />
    )
  }
}
